import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

const OWNER_DEVICE = "vektor_owner_device";

// Cookie-less page-view counting for the owner console. The platform owner's own visits are skipped,
// including when they're signed out on a device they've used before.
export default function PageTracker() {
  const { pathname } = useLocation();
  const { user } = useAuth();
  const first = useRef(true);
  const ready = user !== null;
  const skip = !!user?.platform_owner;
  useEffect(() => {
    if (skip) localStorage.setItem(OWNER_DEVICE, "1");
    if (!ready || skip || localStorage.getItem(OWNER_DEVICE)) return;
    const referrer = first.current ? document.referrer : null;
    first.current = false;
    api.post("/track", { path: pathname, referrer }).catch(() => {});
  }, [pathname, ready, skip]);
  return null;
}
